import { useContext } from "react"
import List from "components/landing/Testimonials"
import {SeoPageContext} from "../SeoPageContext"

export default function Testimonials() {
  const { testimonials, testimonialsTitle } = useContext(SeoPageContext)

  return <List testimonials={testimonials} title={testimonialsTitle} />
}
